<template>
    <div class="hotspot-content">
        <div class="hotspot-title">
            <div class="background"></div>
            <h3>{{ hotspotContent.title }}</h3>
            <a @click.prevent="close" class="close-btn">Close</a>
        </div>
        <img :src="image" v-if="hasImage" />
        <video-player
            v-else-if="hasVideo"
            :video-id="video"
            :start="hotspotContent.start"
            :end="hotspotContent.end"
        />
        <ul v-if="hasBenefits" class="benefits">
            <li
                v-for="(benefit, bindex) in hotspotContent.benefits"
                :key="bindex"
            >
                {{ benefit }}
            </li>
        </ul>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import VideoPlayer from './video-player';

export default {
    props: ['content', 'current'],
    components: { VideoPlayer },
    computed: {
        hotspotContent() {
            return this.current && this.content && this.content[this.current] !== undefined
                ? this.content[this.current]
                : {
                      title: '',
                      type: '',
                      path: ''
                  };
        },
        hasImage() {
            return (
                this.hotspotContent.type == 'image' && this.hotspotContent.path
            );
        },
        image() {
            return `images/hotspots/${this.hotspotContent.path}`;
        },
        hasVideo() {
            return (
                this.hotspotContent.type == 'video' && this.hotspotContent.id
            );
        },
        video() {
            return this.hotspotContent.id;
        },
        hasBenefits() {
            return (
                this.hotspotContent.benefits &&
                this.hotspotContent.benefits.length
            );
        }
    },
    methods: {
        ...mapActions(['setCurrentHotspot']),
        close() {
            this.setCurrentHotspot('');
        }
    }
};
</script>

<style lang="scss">
@import '../assets/sass/_globals/mixins';

.hotspot-content {
    margin-top: 1em;
    position: absolute;
    width: 100%;
    overflow-y: auto;
    height: calc(100vh - 8.75em);

    .hotspot-title {
        position: relative;
        padding: 0.5em 4em 0.5em 1.5em;
        width: 100%;
        min-height: 3em;
        display: flex;
        align-items: center;
        justify-content: center;

        @include at-least($d) {
            padding: 0.75em 5em 0.75em 4.5em;
        }

        > .background {
            background-image: linear-gradient(
                to right,
                #ffffff -5%,
                #004b8d 20%
            );
            transform: skewX(13deg);
            width: 110%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 1.25em;
            z-index: 0;
        }

        h3 {
            position: relative;
            color: #ffffff;
            line-height: 1;
            font-weight: 600;
            font-size: 1.1em;
        }

        .close-btn {
            right: 1.5em;
            top: 50%;
            transform: translateY(-50%);
            width: 2em;
            height: 2em;
            border-radius: 1.25em;

            @include at-least($d) {
                right: 2.5em;
            }
        }
    }

    img {
        margin-top: 1em;
        width: 80%;
        margin-left: 2em;
        border: solid 1px #979797;

        @include between($tp, $tlp) {
            width: 90%;
        }
    }

    .benefits {
        background-color: rgba(255, 255, 255, 0.8);
        list-style: disc;
        padding: 1em 2em;
        margin-top: 1em;
        margin-left: 2.35em;
        width: 80%;
        font-size: 0.85em;

        li {
            margin-bottom: 0.75em;
            font-size: 0.875em;
            line-height: 1.14;
            color: #959595;
            font-family: 'Montserrat', sans-serif;
        }
    }
}
</style>
